// @ts-check
import { get, filter, map } from "lodash";
import { PROJECT_PREFILL_OPTIONS } from "../consts";

export const getForecastAllocationProjects = (allocationProjects) => {
  return map(
    filter(
      allocationProjects,
      (ap) => !ap.isDeleted && (ap.isActive || ap.forecast)
    ),
    (ap) => {
      if (!ap.prefillOption) {
        // eslint-disable-next-line no-param-reassign
        ap.prefillOption = PROJECT_PREFILL_OPTIONS.TODAY;
      }
      return ap;
    }
  );
};

export const getForecastReadonlyFlag = (allocationProject, rootGroup) => {
  const isDemand = get(rootGroup, "isDemand", false);
  if (isDemand) {
    return get(allocationProject, "isRequestorForecastReadonly", false);
  }

  const isSource = get(rootGroup, "isSource", false);
  if (isSource) {
    return get(allocationProject, "isApproverForecastReadonly", false);
  }

  return false;
};

export const getForecastReadonlyMsg = (allocationProject, rootGroup) => {
  const isDemand = get(rootGroup, "isDemand", false);
  if (isDemand) {
    return get(allocationProject, "requestorForecastReadonlyHover", "");
  }

  const isSource = get(rootGroup, "isSource", false);
  if (isSource) {
    return get(allocationProject, "approverForecasteadonlyHover", "");
  }

  return "";
};

export const getIndirectForecastFlg = (groupTypes, group) => {
  const groupType = get(groupTypes, group.type, {});

  return get(groupType, "planning.canHaveIndirectPlaceholderForecasts", false);
};

export const getIndirectForecastTargetFlg = (groupTypes, group) => {
  const groupType = get(groupTypes, group.type, {});

  return get(groupType, "planning.isIndirectPlaceholderForecastTarget", false);
};
